import React, { createContext, useEffect, useState, useRef } from "react";
import { isNull } from "App/utils/helpers";
import { FORM_RESET_DETAIL_PAKET, FORM_RESET_STATE_PAKET_TELE } from "../helpers";
import { MOBILE_INPUT_PAKET_TELEKONSUL } from "App/constants";
import { DEFAULT_SHOW_BUTTON_SUBMIT } from "App/constants";

export const FormContext = createContext();

export const FormProvider = ({ type = "create", children, data, menu }) => {
  const oldFormData = useRef(null);
  const [showModaPaket, setShowModaPaket] = useState(false);
  const [formData, setFormData] = useState(() => {
    if (isNull(data)) {
      return FORM_RESET_STATE_PAKET_TELE;
    } else {
      if (menu === MOBILE_INPUT_PAKET_TELEKONSUL) {
        oldFormData.current = data;
        return data;
      } else {
        if (isNull(oldFormData.current)) {
          return FORM_RESET_STATE_PAKET_TELE;
        } else {
          return oldFormData.current;
        }
      }
    }
  });

  const [listPaket, setListPaket] = useState([]);
  const [formDetail, setFormDetail] = useState(FORM_RESET_DETAIL_PAKET);
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  useEffect(() => {
    if (isNull(data)) {
      setFormData(FORM_RESET_STATE_PAKET_TELE);
    } else {
      if (menu === MOBILE_INPUT_PAKET_TELEKONSUL) {
        oldFormData.current = data;
        setFormData(data);
      } else {
        if (isNull(oldFormData.current)) {
          setFormData(FORM_RESET_STATE_PAKET_TELE);
        } else {
          setFormData(oldFormData.current);
        }
      }
    }
  }, [data]); // eslint-disable-line
  return (
    <FormContext.Provider
      value={{
        formData,
        setFormData,
        listPaket,
        setListPaket,
        disabled,
        setDisabled,
        showModaPaket,
        setShowModaPaket,
        formDetail,
        setFormDetail,
      }}>
      {children}
    </FormContext.Provider>
  );
};
